import "./styles.css";
import React, { useEffect, useState } from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function Time({ label, ampm, value, onChange }) {
  const [selfValue, setSelfValue] = useState(value);

  useEffect(() => {
    setSelfValue(value);
  }, [value]);

  const handleChange = (newValue) => {
    onChange?.(newValue);
    setSelfValue(newValue);
  };

  return (
    <div className="time-picker-container" id="time-container">
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        id="time-localization-provider"
      >
        <p className="time-picker-label" id="time-title">
          {label}
        </p>
        <TimePicker
          value={selfValue}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} />}
          className="time-picker"
          ampm={ampm}
          id="time-picker"
        />
      </LocalizationProvider>
    </div>
  );
}
